import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">题材分类</h2>
          <p className="mt-1 text-sm text-foreground-600">按你喜欢的题材，快速找到心仪韩漫</p>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
        {categories.map((cat) => {
          const tone =
            cat.color === 'primary'
              ? 'bg-primary-100 text-primary-600'
              : cat.color === 'accent'
                ? 'bg-accent-100 text-accent-700'
                : 'bg-secondary-100 text-secondary-700';
          return (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span className={`w-12 h-12 flex items-center justify-center rounded-full ${tone}`}>
                <i className={`${cat.icon} text-2xl`}></i>
              </span>
              <span className="text-sm font-label font-medium text-foreground-800">{cat.name}</span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}